import { FC } from 'react';

const DisabledPagePlaceholder: FC = () => {
  return (
    <div
      className="flex flex-col items-center justify-center gap-6"
      style={{
        minHeight: '100dvh',
        background: 'linear-gradient(160deg, #0c141a 0%, #1d262d 100%)',
      }}
    >
      <div className="relative flex items-center justify-center">
        {/* Outer pulse ring */}
        <div
          className="absolute rounded-full opacity-20"
          style={{
            width: 100,
            height: 100,
            background: 'var(--primaryColor)',
            animation: 'disabledPulse 2.4s ease-in-out infinite',
          }}
        />
        {/* Inner circle */}
        <div
          className="relative flex items-center justify-center rounded-full"
          style={{
            width: 64,
            height: 64,
            background: 'rgba(255,255,255,0.05)',
            border: '1.5px solid rgba(255,255,255,0.12)',
            backdropFilter: 'blur(8px)',
          }}
        >
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.35)" strokeWidth="1.5" strokeLinecap="round">
            <circle cx="12" cy="12" r="10" />
            <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
          </svg>
        </div>
      </div>

      <span
        className="text-xs font-medium uppercase tracking-widest"
        style={{ color: 'rgba(255,255,255,0.35)', letterSpacing: '0.16em' }}
      >
        Page disabled
      </span>

      <style>{`
        @keyframes disabledPulse {
          0%, 100% { transform: scale(1); opacity: 0.15; }
          50% { transform: scale(1.45); opacity: 0.05; }
        }
      `}</style>
    </div>
  );
};

export default DisabledPagePlaceholder;
